import { render, staticRenderFns } from "./RegionsList.vue?vue&type=template&id=cbcf6678&scoped=true"
import script from "./RegionsList.vue?vue&type=script&lang=js"
export * from "./RegionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcf6678",
  null
  
)

export default component.exports